import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submitForm(event) {
    // Submit the form when the select changes
    event.preventDefault()
    this.element.requestSubmit()
  }
}